<template>
  <el-dialog :visible="visible" :title="title" :width="width" custom-class="cargo-form-dialog" @close="handleClose">
    <cargo-form
      :model="model"
      :form-items="formItems"
    />
    <div slot="footer">
      <el-button type="primary" @click="handleSubmit">确认</el-button>
      <el-button @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm'
export default {
  name: 'CargoFormDialog',
  components: { CargoForm },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    width: {
      type: String,
      default: () => '50%'
    },
    formItems: {
      type: Array,
      default: () => []
    },
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  methods: {
    handleSubmit() {
      this.$emit('submit')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.cargo-form-dialog{
  .el-dialog{
    &__header,&__body,&__footer{
      padding:10px 15px!important;
    }
    &__title{
      vertical-align: middle;
    }
    &__headerbtn{
      top:15px;
      right:15px;
    }
  }
}
</style>
